import React from 'react';
import { GenericFieldWrapper } from 'web-ui-components/lib/layout/fieldWrappers';
import { GenericRadio } from 'web-ui-components/lib/data/capture';
import { Field } from 'react-final-form';
import { Content } from '../../../infrastructure/content';
import { isRequired } from '../../../utils/validation';

const OldAddSignatoryNationality = ({ values }) => (
  <Content>
    {({
      nationalityTitle,
      nationalityDefault,
      otherLabel,
      globalRadioError,
      defaultCountryCode
    }) => (
      <Field name="nationality" subscription={{ touched: true, error: true }} validate={isRequired}>
        {({ meta: { touched, error }, input }) => (
          <GenericFieldWrapper
            name="nationality"
            title={nationalityTitle}
            validationMessage={touched && !!error ? globalRadioError : null}
          >
            <GenericRadio.InlineSet
              groupName="nationality"
              items={[
                {
                  id: defaultCountryCode,
                  labelText: nationalityDefault
                },
                {
                  id: otherLabel,
                  labelText: otherLabel
                }
              ]}
              {...input}
              selectedId={values.nationality}
            />
          </GenericFieldWrapper>
        )}
      </Field>
    )}
  </Content>
);

export default OldAddSignatoryNationality;
